import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _isEqual from 'lodash/isEqual';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import _find from 'lodash/find';
import _get from 'lodash/get';
import { checkUrlExtension, replaceSubdomain } from 'yoda-core-components/lib/helpers/Utils/Utils';
import QuickAddToCart from '../QuickAddTocart/QuickAddToCart';
import * as styles from './HotDeals.css';
import CertonaZoneIris from '../CertonaZoneIris/CertonaZoneIris';
import ProductCard from '../ProductCard/ProductCard';
import { cardTypes } from '../ProductCard/ProductCard.config';
import TimerWrapper from '../TimerWrapper/TimerWrapper';
import YodaProductCartridge from '../YodaProductCartridge/YodaProductCartridge';

const cx = classNames.bind(styles);

/* istanbul ignore next */
const miniPDP = (item, url) => {
    const themeConfig = {
        wrapperClass: cx('hotDealsWrapper', 'noPad'),
        buttonCustomClass: styles.hotDealsminiPDPBtn,
    };
    return (
        <QuickAddToCart
            enableMiniPDP={item.enableMiniPDP}
            ppId={item.id}
            url={url}
            iconStyle
            automationId="miniPDPAddtoCart"
            location="hp-hot-deal"
            themeConfig={themeConfig}
        />
    );
};

/* istanbul ignore next */
const prepareCertonZone = (slotDetails, deviceType, emptyProductsReceived, enableMiniPDP) => {
    const page = `${slotDetails.pageType}-${slotDetails.slotId}`;
    const disableLazyLoad = !deviceType.isDesktop;
    return (
        <CertonaZoneIris
            disableLazyLoad={disableLazyLoad}
            emptyProductsReceived={emptyProductsReceived}
            enableMiniPDP={enableMiniPDP}
            productItemClass={cx('hotDealsCertonaProductItem')}
            page={page}
            slotDetails={slotDetails}
            schemasToRender={slotDetails.slotId}
        />
    );
};

export class HotDeals extends Component {
    static defaultProps = {
        featureFlags: {},
        pricingConfig: {},
        slotId: '',
        deviceType: {},
        pageType: '',
        attributes: '',
        timerZone: '',
        hotDealsCartridgeSlots: {},
        preferences: {},
    };

    static propTypes = {
        featureFlags: {},
        pricingConfig: PropTypes.object,
        slotId: PropTypes.string,
        deviceType: PropTypes.object,
        pageType: PropTypes.string,
        attributes: PropTypes.object,
        timerZone: PropTypes.string,
        hotDealsCartridgeSlots: PropTypes.object,
        preferences: PropTypes.object,
    };

    constructor(props) {
        super(props);
        this.emptyProductsReceived = this.emptyProductsReceived.bind(this);
        this.state = {
            emptyProducts: false,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        return !_isEqual(nextProps, this.props) || !_isEqual(nextState, this.state);
    }

    // Query param separator
    /* istanbul ignore next */
    getQueryParamSeparator = (url) => (url && url.indexOf('?') === -1 ? '?' : '&');

    getProductHotDealsCatridge = (recordsInfoList, panelTitle) => {
        const { deviceType, pricingConfig, pageType } = this.props;
        /* istanbul ignore else */
        if (recordsInfoList && recordsInfoList.length > 0) {
            const disableLazyLoad = !deviceType.isDesktop;
            return (
                <YodaProductCartridge
                    productCartridgeList={recordsInfoList}
                    pricingConfig={pricingConfig}
                    slotId={Date.now()}
                    key={Math.random()}
                    customRenderProductCard={deviceType}
                    deviceType={deviceType}
                    cartridgeListRenderer={this.defaultcardListRenderer}
                    disableLazyLoad={disableLazyLoad}
                    pageType={pageType}
                    panelType="HOTDEAL"
                    panelTitle={panelTitle}
                    productCatridgeTheme={cx('hotDealsProdCatridge')}
                    prodCatridgeWrapper={cx('hotDealsWrapper')}
                    fromHotDeals
                />
            );
        }
        /* istanbul ignore next */
        return null;
    };

    /* istanbul ignore next */
    getChannel = (deviceType) => {
        let channel = '';
        if (deviceType.isMobile) {
            channel = 'MW';
        } else if (deviceType.isTablet) {
            channel = 'TW';
        } else {
            channel = 'DT';
        }
        return channel;
    };

    /* istanbul ignore next */
    getDeviceType() {
        const { deviceType } = this.props;
        if (deviceType.isMobile) {
            return 'mobile';
        }
        if (deviceType.isTablet) {
            return 'tablet';
        }
        return 'dotcom';
    }

    // Checks whether to open in New Tab
    getTargetWindow(openInNewTab = false) {
        return openInNewTab ? '_blank' : '_self';
    }

    // Binding items to product card
    /* istanbul ignore next */
    defaultcardListRenderer = (item, listContext, highlightCardSlot, setImageHeight) => {
        const dataItem = this.decorateToCartridgeList(item);
        const { linkURL, analyticsTag, priceDetails } = dataItem;
        const linkUrlWithSlotId = linkURL
            ? linkURL.concat(`${this.getQueryParamSeparator(linkURL)}${analyticsTag}`)
            : linkURL;

        const {
            featureFlags: { enableMiniPDPFeature },
            pricingConfig: { disableFPACAPI },
            deviceType,
        } = this.props;
        const enableNewPriceFormat = disableFPACAPI === false;
        const prodCardStyle = enableMiniPDPFeature
            ? cx('productCard', 'miniPdpProductCard', {
                  hotDealsNewPriceWrapper: enableNewPriceFormat,
              })
            : cx('productCard', 'productCatridge', {
                  hotDealsNewPriceWrapper: enableNewPriceFormat,
              });
        return (
            <a
                href={linkUrlWithSlotId}
                className={cx('linkColor', 'productPanelLinkBlock')}
                data-automation-id="reczone-hotdeals-link"
                onClick={(e) => {
                    listContext &&
                        listContext.onPaneClick &&
                        listContext?.onPaneClick(e, dataItem.index, linkUrlWithSlotId);
                }}
            >
                <ProductCard
                    customClass={prodCardStyle}
                    pricingConfig={this.props.pricingConfig}
                    cardCustomClass={cx('hotDealsCard')}
                    imageUrl={dataItem.imageURL}
                    title={dataItem.name}
                    price={priceDetails}
                    key={dataItem.id}
                    cardType={cardTypes.GRID}
                    rating={Number(dataItem.rating)}
                    reviewCount={dataItem.reviews}
                    cardTheme="cartridge"
                    deviceType={deviceType}
                    skuId={dataItem.skuId}
                    skuSwatch={dataItem.skuSwatch}
                    eligibilityMessage={(priceDetails || {}).eligibilityMessage || ''}
                    automationId="hotdeals-cartridge-product-list"
                    fromHotDeals
                    setImageHeight={setImageHeight}
                >
                    {this.props.featureFlags.enableMiniPDPFeature
                        ? miniPDP(dataItem, linkUrlWithSlotId)
                        : null}
                </ProductCard>
            </a>
        );
    };

    /* istanbul ignore next */
    decorateToCartridgeList = (item) => {
        if (item) {
            const {
                url,
                originalMax,
                originalMin,
                currentMin,
                currentMax,
                reviewCount,
                averageRating,
                ppId,
                imageId,
                marketingLabel,
                eligibilityMessage,
                currentPriceLabel,
                mapPrice,
                enableMiniPDP,
                fpac,
                promotions,
                eachLabel,
            } = item;
            const manufacturerAdvertised = mapPrice === 'true';
            item.reviews = Number.parseInt(reviewCount, 10);
            item.rating = averageRating;
            item.id = ppId;
            const matchImage = /scene7.com(.+)/g.test(imageId);
            item.imageURL = matchImage
                ? imageId
                : `//s7d1.scene7.com/is/image/JCPenney/${imageId}?wid=170&hei=170&op_sharpen=1`;
            item.linkURL = url;
            item.enableMiniPDP = !!enableMiniPDP;
            const priceEmpty = this.isPriceEmpty(item);
            if (!priceEmpty) {
                item.priceDetails = {
                    amounts: [
                        {
                            min: parseFloat(originalMin),
                            max: parseFloat(originalMax),
                            type: 'original',
                            minPercentOff: 0,
                            maxPercentOff: 0,
                        },
                        {
                            min: parseFloat(currentMin),
                            max: parseFloat(currentMax),
                            type: currentPriceLabel || 'original',
                            minPercentOff: 0,
                            maxPercentOff: 0,
                        },
                    ],
                    marketingLabel,
                    manufacturerAdvertised,
                    promotions,
                    eachLabel,
                    eligibilityMessage,
                };
                const { disableFPAC } = this.props.pricingConfig;
                if (!disableFPAC) {
                    item.priceDetails.fpac = fpac;
                }
            }
        }
        return item;
    };

    // TODO: Enable below method when certona ready for production.
    // loading certona info using product cartridge component
    /* istanbul ignore next */
    loadCertonaSchema = (hotDealsSchema) => {
        const { deviceType } = this.props;
        const { enableHotDealCertonaMiniPDP } = this.props.pricingConfig;
        const slotDetails = {
            automationId: 'test-automation-product-cartridge-B',
            pageType: this.props.pageType,
            loader: 'certona',
            slotId: hotDealsSchema,
            attributes: this.props.attributes,
        };
        return (
            <>
                {prepareCertonZone(
                    slotDetails,
                    deviceType,
                    this.emptyProductsReceived,
                    enableHotDealCertonaMiniPDP
                )}
            </>
        );
    };

    loadHotDealsBanner = (hotdeals, UrgencyMessageEnabled, preferences) => {
        const {
            seoUrl,
            shopAllTitle,
            marketingTagLineColor,
            backGroundColor,
            imagePath,
            analyticsTag,
            timerEnabled,
            marketingHeadLine,
            openInNewTab,
        } = hotdeals;

        let { marketingTagLine } = hotdeals;
        if (marketingTagLine && marketingTagLine.length > 32) {
            marketingTagLine = marketingTagLine.substring(0, 32);
        }
        const { deviceType } = this.props;
        const marketingTagLineBGColor = {};
        if (!deviceType.isDesktop) {
            marketingTagLineBGColor.background = backGroundColor; // hot deals banner backgound color
        }

        // Seo tagging
        const seoTaggingUrl = this.generageSEOTagginURL(seoUrl, analyticsTag);

        // Opening Tab
        const targetWindow = this.getTargetWindow(openInNewTab);

        // display Marketing style
        const displayMarketingButton = shopAllTitle
            ? { visibility: 'visible', background: marketingTagLineColor }
            : { visibility: 'hidden', background: marketingTagLineColor };

        // Marketing tag line color
        const marketingTagLineStyle = { color: marketingTagLineColor };
        const matchImagePath =
            /\/dotcom\/(.+)/g.test(imagePath) ||
            /\/tablet\/(.+)/g.test(imagePath) ||
            /\/mobile\/(.+)/g.test(imagePath) ||
            /^(http|https):\/\//g.test(imagePath);
        const imageFullPath = matchImagePath
            ? imagePath
            : `/${this.getDeviceType()}/images/${imagePath}`;

        const imageExt = checkUrlExtension(imageFullPath);
        const convUrl = replaceSubdomain(imageFullPath, preferences);

        return (
            <div className={cx('hotDeals')} style={marketingTagLineBGColor}>
                {/* banner background color coming from service response */}
                <div className={cx('hotDealsInfo')}>
                    <div className={cx('hotDealsTextInfo')}>
                        {/* Banner content -- from API response */}
                        <div
                            data-automation-id="hotdeals-image"
                            className={cx('hotDealsImage', 'forLargerScreens')}
                        >
                            {imageExt === 'mp4' ? (
                                <video
                                    playsInline
                                    autoPlay
                                    muted
                                    loop
                                    width="100%"
                                    height="100%"
                                    className={cx('hotDealsVideo')}
                                >
                                    <source
                                        src={convUrl}
                                        type="video/mp4"
                                        automationId="responsive-component-image-video"
                                        alt="Hot Deals"
                                        ariaLabel="responsive-component-image"
                                    />
                                </video>
                            ) : (
                                <img
                                    className={cx('hotDealsImg')}
                                    src={replaceSubdomain(imageFullPath, preferences)}
                                    alt="Hot Deals"
                                />
                            )}
                        </div>

                        {/* Only for Larger Screens */}
                        <div className={cx('title-wrapper')} style={marketingTagLineStyle}>
                            {marketingHeadLine ? (
                                <h3
                                    className={cx('hotDealsSubText', 'forLargerScreens')}
                                    data-automation-id="hotdeals-title"
                                >
                                    {marketingHeadLine}
                                </h3>
                            ) : (
                                ''
                            )}
                            {marketingTagLine ? (
                                <h4
                                    data-automation-id="hotdeals-subtitle"
                                    className={cx('hotDealsSubTitle-largeScreen')}
                                >
                                    {marketingTagLine}
                                </h4>
                            ) : (
                                ''
                            )}
                        </div>
                        {/* Only for Larger Screens Ends */}

                        {timerEnabled &&
                            UrgencyMessageEnabled &&
                            this.displayTimerControl(hotdeals)}
                        {/* Only for Larger Screen Ends */}
                    </div>
                    <div className={cx('hotDealsCta')}>
                        {/* button background color and content coming from server */}
                        <a
                            className={cx('hotDealsLink')}
                            data-automation-id="hot-deals-link"
                            href={seoTaggingUrl}
                            target={targetWindow}
                            style={displayMarketingButton}
                        >
                            {shopAllTitle}
                        </a>
                    </div>
                </div>
            </div>
        );
    };

    displayTimerControl = (hotdeals) => {
        const {
            liveText: liveTextLabel,
            timerTextColor: liveTextLabelColor,
            liveTextColor: timerTextColor,
            timer: finishTime,
        } = hotdeals;
        const { timerZone } = this.props;
        const timerProps = {
            liveTextLabel,
            liveTextLabelColor,
            timerTextColor,
            finishTime,
            timerTextConfig: {
                h: 'hrs',
                m: 'min',
                s: 'sec',
            },
            timerZone,
        };
        return (
            <div className={cx('timerBlock')}>
                <TimerWrapper {...timerProps} removeTimerZeros />
            </div>
        );
    };

    /**
     * stripping zero priced product items
     */
    isPriceEmpty = (item) =>
        (!item.originalMax || item.originalMax === '0') &&
        (!item.originalMin || item.originalMin === '0') &&
        (!item.currentMin || item.currentMin === '0') &&
        (!item.currentMax || item.currentMax === '0');

    generageSEOTagginURL = (seoUrl, analyticsTag) => {
        const channelAnalyticsTag =
            analyticsTag && `${analyticsTag}_${this.getChannel(this.props.deviceType)}`;
        return seoUrl && String(seoUrl).toLowerCase().indexOf('cm_re') === -1
            ? `${seoUrl}${this.getQueryParamSeparator(seoUrl)}${channelAnalyticsTag || ''}`
            : seoUrl;
    };

    displaySmallBanner = (hotdeals, UrgencyMessageEnabled, filteredrecordsListWithouAmounts) => {
        const {
            marketingTagLine,
            marketingHeadLine,
            seoUrl,
            analyticsTag,
            shopAllTitle,
            timerEnabled,
            openInNewTab,
        } = hotdeals;

        // Opening Tab
        const targetWindow = this.getTargetWindow(openInNewTab);

        // Seo tagging
        const seoTaggingUrl = this.generageSEOTagginURL(seoUrl, analyticsTag);
        return (
            (filteredrecordsListWithouAmounts.length > 0 || hotdeals.certonaEnabled) && (
                <div className={cx('hotDealsTitleBtnTimerBlock')}>
                    <div className={cx('hotDealsTitleBtnBlock')}>
                        <div className={cx('hotDealsTitleBlock')}>
                            <div className={cx('hotDealsTitleBtnBlock')}>
                                <h3
                                    className={cx('hotDealsTitle')}
                                    data-automation-id="hotdeals-title"
                                >
                                    {marketingHeadLine}
                                </h3>
                                <div className={cx('hotDealsViewAllBlock')}>
                                    <a
                                        className={cx('hotDealsviewAll')}
                                        data-automation-id="hot-deals-link"
                                        href={seoTaggingUrl}
                                        target={targetWindow}
                                    >
                                        {shopAllTitle}
                                    </a>
                                </div>
                            </div>
                            <h4
                                data-automation-id="hotdeals-subtitle"
                                className={cx('hotDealsSubTitle')}
                            >
                                {marketingTagLine}
                            </h4>
                        </div>
                    </div>
                    {/* displaying timer based on feature-flag */}
                    {timerEnabled && UrgencyMessageEnabled && this.displayTimerControl(hotdeals)}
                </div>
            )
        );
    };

    emptyProductsReceived() {
        this.setState({ emptyProducts: true });
    }

    render() {
        if (this.state.emptyProducts) {
            return null;
        }
        const { hotDealsCartridgeSlots, slotId, featureFlags, preferences } = this.props;
        const { UrgencyMessageEnabled } = featureFlags;

        if (hotDealsCartridgeSlots && Object.keys(hotDealsCartridgeSlots).length > 0) {
            // fetching hotdeal from slot which is supplied from component.
            const hotdeals = _find(
                hotDealsCartridgeSlots,
                (slots) => (slots && slots.type) === slotId
            );
            /* istanbul ignore else */
            if (hotdeals) {
                const { certonaStrategy, certonaEnabled, recordsInfoList = [] } = hotdeals;
                // if recommendation zone is empty we don't show respective banner
                /* istanbul ignore else */

                if ((recordsInfoList && recordsInfoList.length > 0) || certonaEnabled) {
                    // stripping zero priced product items
                    const filteredrecordsList = recordsInfoList;

                    return (
                        <>
                            {/* displaySmallBanner: will render hotdeals banner only for small & medium scales */}
                            {this.displaySmallBanner(
                                hotdeals,
                                UrgencyMessageEnabled,
                                filteredrecordsList
                            )}
                            <div className={cx('hotDealsBlock', 'hotDealsMfr')}>
                                {((filteredrecordsList && filteredrecordsList.length > 0) ||
                                    certonaEnabled) &&
                                    this.loadHotDealsBanner(
                                        hotdeals,
                                        UrgencyMessageEnabled,
                                        preferences
                                    )}
                                {
                                    // Loading recommentations based on certonaEnabled flag
                                    certonaEnabled
                                        ? this.loadCertonaSchema(certonaStrategy)
                                        : this.getProductHotDealsCatridge(
                                              filteredrecordsList,
                                              hotdeals.marketingHeadLine
                                          )
                                }
                            </div>
                        </>
                    );
                }
            }
        }
        return null;
    }
}

const mapStateToProps = (state) => ({
    featureFlags: state.context ? state.context.featureFlags : {},
    pricingConfig: _get(state, 'context.preferences.fpac.hotDeal', {}),
    timerZone: state.context && state.context.preferences ? state.context.preferences.timeZone : {},
    preferences: _get(state, 'context.preferences', {}),
});

export default connect(mapStateToProps)(HotDeals);
